export default {
    // 俄语
    LOCALE_HTML: {
        'msg.language': 'ru',
        'msg.title': 'заглавие',
        'msg.type': 'тип вопроса',
        'msg.des': 'описание вопроса',
        'msg.phone': 'номер телефона',
        'msg.regionCode': 'Код города',
        'msg.email': 'почта',
        'msg.choose': 'выбирайте типы',
        'msg.detail': 'деталь записи',
        'msg.back': 'назад',
        'your.msg': 'записывайте ',
        'msg.record': 'запись сообщення',
        'msg.success': 'успешно записать ',
        'to.record': 'записать',
        completed: 'завершено ',
        submit: 'представить',
        'success.desc': 'ваш комментарий успешно представлен ',
        'msg.form.input': 'входите',
        'msg.reply': 'ответить',
        'comment.suc': 'благодарить за ваш комментарий!',
        'comment.fail': 'неудачно представлен ',
        'comment.placeholder':
            'преветствовать представить предложения по нашим услугам',
        'reply.suc': 'успешно представлен!',
        'reply.fail': 'входите ваши ответы',
        'reply.placeholder': 'входите ваши ответы',
        'msg.more': 'осмотреть больше',
        'msg.collapse': 'убрать ',
        'msg.myservice': 'оценка моей услуги',
        'msg.evaluate': 'оценка услуги',
        'msg.evaluateTitle': 'оценка услуги',
        'msg.score': 'баллы оценки',
        'msg.remark': 'замечание',
        'msg.status.created': 'создано',
        'msg.status.pending': 'принять к рассмотрению',
        'msg.status.processing': 'в принятии',
        'msg.status.solved': 'решено',
        'msg.service.reply': 'ответ сервиса',
        'msg.my.reply': 'Ваш Oтвет',
        'msg.toast.des': 'описание вопроса было пустым',
        'msg.toast.type': 'тип вопроса был пустым',
        'msg.toast.title': 'заглавие было пустым',
        'msg.toast.none': 'нельзя быть пустым',
        'msg.toast.noAnnex': 'прикрепитесь приложение',
        'msg.toast.noEmail': 'почта не может быть пустой',
        'msg.toast.noTel': 'номер телефона не может быть пустым',
        'msg.toast.noRegionCode': 'Код города не может быть пустым',
        'msg.toast.noZone': 'Пожалуйста, выберите часовой пояс',
        'msg.toast.noDateTime': 'Пожалуйста, выберите дату и время',
        'msg.toast.email': 'входите правильную почту',
        'msg.toast.tel': 'входите правильный номер телефона',
        'msg.toast.regionCode': 'Пожалуйста, выберите код города',
        'msg.toast.num': 'входить правильные цифры',
        'msg.toast.annex': 'прикрепись приложение',
        'msg.toast.char': 'входите правильные знаки',
        'msg.list.none': 'нет данных',
        'msg.form.choose': 'выбирайте ',
        'msg.form.chooseZone': 'Выберите часовой пояс',
        'msg.form.chooseTime': 'Выбрать время',
        'msg.form.chooseDate': 'Выбрать дату',
        'msg.form.sure': 'решить',
        'msg.form.search': 'искать',
        'msg.form.uploadError': 'неправильный формат',
        'msg.form.uploadXss':
            'Памылка загрузкі, змесціва файла змяшчае недапушчальны сцэнар',
        'msg.update.time': 'возобновить',
        'msg.replace.images': 'картина',

        MSG016: 'решено',
        MSG017: 'нерешенный',
        MSG019: 'представлять на рассмотрение',
        MSG072: 'Ярлык оценки не может быть пустым! ',
        MSG073: 'Язык оценки не может быть пустым! ',
        MSG074: 'Этикетка:',
        MSG075: 'Решено ли:',
        MSG076: 'Пожалуйста, выберите, решена ли проблема',
        MSG015: 'Этот билет решил вашу проблему?',

        'file.size.limit': 'размер файла не првыше 50 мб ',
        'detail.file.limit':
            'количество файла не првыше 15, размер не превыше 50 мб',
        'form.question.des.tip': 'входите описание вопроса',
        'form.title.tip': 'входите заглавие',
        'form.class.tip': 'выбирайте тип вопроса',
        'upload.file': 'загрузить файлы',
        'file.count.limit': 'прикрепиться файлы не больше 15',
        'select.search.placeholder': 'искать ключевые слова',
        'msg.form.sizeError1': 'прикрепитесь приложение меньше 5 мб',
        'msg.form.sizeError2': 'прикрепитесь приложение меньше 50 мб',
        'msg.form.submit': 'представить ',
        'msg.form.upload': 'прикрепиться',
        'msg.email.tip1': 'не нашли ваши комментарии ',
        'msg.email.tip2':
            'если у вас было комментарии, сможете проверять с помощью заверки почты',
        'msg.email.tip3': 'начать заверку почты',
        'msg.email.noData': 'нет данных в этом аккаунте',
        'email.verify.tip': 'использованный адрес почты во время входа записи',
        'email.input.placeholder': 'входите адрес почты',
        'email.submit': 'отправить е-мейл',
        'email.rules.error': 'входите правильную почту',
        'email.code.tip': 'е-мейл отправлен, входите принятую капчу',
        'email.code.placeholder': 'входите капчу',
        'email.code.submit': 'сразу осмотреть',
        'email.notFind.customer': 'не нашли статистику клиента ',
        'email.code.wrong': 'капча неправильная, ещё раз входите',
        'email.code.expired': 'капча просрочена, ещё раз прверять почту',
        'email.code': 'капча',
        'email.send.frequently':
            'операция выполняется слишком часто, дождитесь операции',
        'comment.fail.400133': 'Этот билет был оценен',
        'not.get.user.info': 'Невозможно получить вашу информацию',
        'user.verify.tip':
            'Вам нужно пройти проверку, чтобы просмотреть содержимое списка сообщений.',
        'verify.type.email': 'Проверка почтового ящика',
        'verify.text': 'Проверка',
        'cancel.text': 'Отменить',
        'get.verify.code': 'Получение кода проверки',
        'reGet.verify.code': 'Повторное приобретение ',
        'verify.by.email.tip':
            'Код аутентификации будет отправлен по электронной почте в учетную запись почтового ящика, которую вы ввели.',
        'verify.type.phone': 'Проверка текстовых сообщений',
        'phone.placeholder': 'Пожалуйста, введите номер телефона.',
        'verify.by.phone.tip':
            'Код проверки будет отправлен через SMS на номер телефона, который вы ввели.',
        'phone.error': 'Пожалуйста, введите правильный номер телефона.',
        'phone.errorCode400150': 'Коды часто передаются ',
        'phone.errorCode400233':
            'Шаблоны текстовых сообщений не могут быть пустыми ',
        'phone.errorCode400234':
            'Недостаточный баланс маркетинговых сообщений ',
        'phone.errorCode400235': 'Недостаточный остаток SMS ',
        'phone.errorCode400247': 'Ошибка настройки модуля SMS ',
        'phone.errorCode4400248': 'Ошибка получения шаблона SMS',
        'phone.errorCode400249': 'Номер телефона не является существующим.',
        'phone.errorCode400250':
            'Код проверки истек, пожалуйста, получите его снова',
        'msg.you.reply': 'Ответил Bам',
        'msg.no.reply':'нет ответа',
    },
    LOCALE_REQUEST: {
        400016: 'Срок получения информации о заказе на работу истек, обновите!'
    },
    LOCALE_SYSTEM: {
        MSG005: ({ name }) =>
            `Conversation with ${name} has been ended temporarily`,
        MSG012: (color) =>
            ` You can <span style="color:${color};text-decoration:underline;" class="js-leave-msg">Leave message</span>`,
        MSG013: 'Send'
    },
    LOCALE_EDITOR: {
        editor: {
            base: {
                remove: 'Удалить',
                cancel: 'Отмена',
                confirm: 'Подтвердить',
                insert: 'Вставить',
                width: 'Ширина',
                height: 'Высота'
            },
            controls: {
                clear: 'Очистить',
                undo: 'Отменить',
                redo: 'Повторить',
                fontSize: 'Размер шрифта',
                color: 'Цвет',
                textColor: 'Цвет текста',
                tempColors: 'Temp Colors',
                backgroundColor: 'Цвет фона',
                bold: 'Жирный',
                lineHeight: 'Межстрочный интервал',
                letterSpacing: 'Межбуквенный интервал',
                textIndent: 'Отступ',
                increaseIndent: 'Увеличить отступ',
                decreaseIndent: 'Уменьшить отступ',
                italic: 'Курсив',
                underline: 'Подчеркнутый',
                strikeThrough: 'Перечеркнутый',
                fontFamily: 'Шрифт',
                textAlign: 'Расположение текста',
                alignLeft: 'По левому краю',
                alignCenter: 'По центру',
                alignRight: 'По правому краю',
                alignJustify: 'По ширине',
                floatLeft: 'Обтекание слева',
                floatRight: 'Обтекание справа',
                superScript: 'Надстрочный индекс',
                subScript: 'Подстрочный индекс',
                removeStyles: 'Убрать стили',
                headings: 'Заголовки',
                header: 'Заголовок',
                normal: 'Обычный',
                orderedList: 'Упорядоченный список',
                unorderedList: 'Неупорядоченный список',
                blockQuote: 'Цитата',
                code: 'Код',
                link: 'Вставить ссылку',
                unlink: 'Убрать ссылку',
                hr: 'Горизонтальная линия',
                media: 'Медиа',
                mediaLibirary: 'Медиа библиотека',
                emoji: 'Emoji',
                fullscreen: 'Полноэкранный режим',
                exitFullscreen: 'Выйти из полноэкранного режима'
            },
            linkEditor: {
                textInputPlaceHolder: 'Введите текст ссылки',
                linkInputPlaceHolder: 'Вставить ссылку',
                inputWithEnterPlaceHolder: 'Вставить ссылку и нажать Enter',
                openInNewWindow: 'Открыть в новом окне',
                removeLink: 'Убрать ссылку'
            },
            audioPlayer: {
                title: 'Воспроизвести аудиофайл'
            },
            videoPlayer: {
                title: 'Воспроизвести видеофайл',
                embedTitle: 'Embed Media'
            },
            media: {
                image: 'Картинка',
                video: 'Видео',
                audio: 'Аудио',
                embed: 'Встроенное'
            }
        },
        finder: {
            remove: 'удалить',
            cancel: 'Отмена',
            confirm: 'подтверждать',
            insert: 'вставить выбранный элемент',
            width: 'ширина',
            height: 'высокий',
            image: 'Видео',
            video: 'видео',
            audio: 'Аудио',
            embed: 'Embed Media',
            caption: 'Медиа библиотека',
            dragTip: 'Нажмите или перетащите файл сюда',
            dropTip: 'Отпустите, чтобы загрузить',
            selectAll: 'выбрать все',
            deselect: 'отменить выбор',
            removeSelected: 'удалить выбранный элемент',
            externalInputPlaceHolder: 'Имя ресурса|Адрес ресурса',
            externalInputTip:
                'Используйте «|», чтобы разделить имя ресурса и адрес ресурса.',
            addLocalFile: 'Добавьте локальные ресурсы',
            addExternalSource: 'Добавить веб-ресурс',
            unnamedItem: 'безымянный проект',
            confirmInsert: 'Вставить выбранный элемент'
        }
    }
}
